import update from 'immutability-helper';
import { CLEAR_CATEGORY, FETCH_CATEGORY } from 'src/common/actions/browse';
import { fulfilled } from './utils/asyncActionNameSuffixes';
import createContainerNavigationHandlers from './utils/createContainerNavigationHandlers';
import createMappedReducer from './utils/createMappedReducer';
import createRequestLifecycleHandlers from './utils/createRequestLifecycleHandlers';

export const categories = createMappedReducer(
  {},
  {
    ...createRequestLifecycleHandlers({ fetchActionNameRoot: FETCH_CATEGORY }),
    ...createContainerNavigationHandlers(),
    [fulfilled(FETCH_CATEGORY)](state, action) {
      const { contentId } = action.meta || {};
      const { content = {}, loadedTime } = action.payload || {};

      return update(state, {
        [contentId]: {
          $merge: {
            ...content,
            containers: content?.containers,
            loadedTime,
            isFetching: false,
          },
          $unset: ['hasFailed', 'hasOmittedContainers'],
        },
      });
    },
    [CLEAR_CATEGORY](state, action) {
      return update(state, {
        $unset: [action.guideId],
      });
    },
  },
);
